import React, {useContext, useEffect, useState} from 'react';
import classes from './Dashboard.module.scss';
import machine from '../assets/machine/t7.jpg';
import device from '../assets/device/tl101.png';
import Card from "../components/Card";
import {YMaps, Map, Placemark} from '@pbe/react-yandex-maps';
import {
    getCode,
    getCurrent,
    getDevice,
    getFW,
    getHumidity,
    getHW,
    getICCID,
    getIMEI,
    getLat,
    getLon,
    getPdo0,
    getPdo1,
    getRSSI,
    getTemperature,
    getVoltage,
    updateDevice
} from "../http/deviceAPI";
import {observer} from "mobx-react-lite";
import {Context} from "../index";
import DateAndTimePicker from "../components/DateAndTimePicker";
import {DateTimePicker} from "@mui/x-date-pickers"
import {useNavigate} from "react-router";
import dayjs from "dayjs";
import {useSnackbar} from 'notistack';
import {
    mdiChevronLeft,
    mdiChevronRight,
    mdiCog,
    mdiWifiCancel,
    mdiWifi,
    mdiSignalCellularOutline,
    mdiSignalCellular1,
    mdiSignalCellular2,
    mdiSignalCellular3,
} from "@mdi/js";
import Icon from "@mdi/react";
import Chart from "../components/Chart";
import Loader from "../components/Loader";
import MainCard from "../components/MainCard";
import {checkAuth, fetchCert} from "../http/userAPI";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import {cborCoder} from "../utils/cbor";
import mqtt from 'mqtt';
import PieChart from "../components/PieChart";
import {nullFilter} from "../utils/nullFilter";
import {AUTH_ROUTE} from "../utils/consts";

const Dashboard = observer(() => {
//-------Константы------------------
    const {user} = useContext(Context)
    const {messages} = useContext(Context)
    const {things} = useContext(Context)
    const {channels} = useContext(Context)
    const {ui} = useContext(Context)
    const {cert} = useContext(Context)
    const {enqueueSnackbar} = useSnackbar();
    const [firstTime, setFirstTime] = useState(dayjs().subtract(24, 'hours'))
    const [lastTime, setLastTime] = useState(dayjs())
    const [diffTime, setDiffTime] = useState(lastTime.diff(firstTime))
    const [maxLastTime, setMaxLastTime] = useState(dayjs())
    const [voltage, setVoltage] = useState(null)
    const [current, setCurrent] = useState(null)
    const [temperature, setTemperature] = useState(null)
    const [humidity, setHumidity] = useState(null)
    const [working, setWorking] = useState(null)
    const [idle, setIdle] = useState(null)
    const [charging, setCharging] = useState(null)
    const [efficiency, setEfficiency] = useState(null)
    const [isModal, setIsModal] = useState(false)
    const [description, setDescription] = useState(things.equipment.description)
    const [facility, setFacility] = useState(things.equipment.facility)
    const [manufacturer, setManufacturer] = useState(things.equipment.manufacturer)
    const [model, setModel] = useState(things.equipment.model)
    const [sn, setSn] = useState(things.equipment.sn)
    const [type, setType] = useState(things.equipment.type)
    const [city, setCity] = useState(things.equipment.city)
    const [address, setAddress] = useState(things.equipment.address)
    const [voltageFactor, setVoltageFactor] = useState(things.settings?.voltage_factor)
    const [currentFactor, setCurrentFactor] = useState(things.settings?.current_factor)
    const [isIMEI, setIsIMEI] = useState(false)
    const [isICCID, setIsICCID] = useState(false)
    const [isFW, setIsFW] = useState(false)
    const [isHW, setIsHW] = useState(false)
    const [isMeta, setIsMeta] = useState(false)
    const [isVoltage, setIsVoltage] = useState(false)
    const [isCurrent, setIsCurrent] = useState(false)
    const [isTemperature, setIsTemperature] = useState(false)
    const [isHumidity, setIsHumidity] = useState(false)
    const [isPdo0, setIsPdo0] = useState(false)
    const [isPdo1, setIsPdo1] = useState(false)
    const [intPower, setIntPower] = useState([0, 0])
    const [intCapacity, setIntCapacity] = useState([0, 0])
    const [isPieChart, setIsPieChart] = useState(false)
    const [update, setUpdate] = useState(false)
    const navigate = useNavigate();
    const auth = {
        username: "webdav", password: "TzkK9DsHmcS9MW.xjqv5"
    };
    const certUrls = ["https://iot.faradaydc.ru/firmware/gate/info@faradaydc.com/certs/bundle_pem.json", "https://iot.faradaydc.ru/firmware/gate/info@faradaydc.com/certs/thing_crt.json", "https://iot.faradaydc.ru/firmware/gate/info@faradaydc.com/certs/thing_key.json"]
    const metadata = {
        "equipment": {
            "description": `${description}`,
            "facility": `${facility}`,
            "manufacturer": `${manufacturer}`,
            "model": `${model}`,
            "sn": `${sn}`,
            "type": `${type}`,
            "city": `${city}`,
            "address": `${address}`,
        }, "settings": {
            "current_factor": currentFactor, "voltage_factor": voltageFactor
        }, "version": 2
    }


    const code = (data) => {
        let array = []
        const description = {
            [1]: 'Включение',
            [2]: 'Выключение',
            [3]: 'Перезагрузка',
            [4]: 'Завершение приложения',
            [5]: 'Включение батарейки',
            [6]: 'Выключение батарейки',
        }
        data.map((i) => {
            array.push({
                time: dayjs(i.time * 1000).format('HH:mm:ss DD/MM/YYYY'),
                code: i.value,
                desc: description[i.value] || '-'
            })
        })
        return array
    }
//------Дополнительные функции------

    const setRange = () => {
        let d = dayjs(firstTime).add(24 * 7, 'hour')
        if (d > dayjs()) {
            d = dayjs()
        }
        setMaxLastTime(d)
    }

    const updateFirstTime = (hours) => {
        let d = lastTime.subtract(hours, 'hours')
        setFirstTime(d)
    }

    const handleCopyText = async (text, variant) => {
        try {
            await navigator.clipboard.writeText(text);
            enqueueSnackbar('Скопировано!', {variant});
        } catch (err) {
        }
    };



    const powerChart = () => {
        let power = [];
        let item = 0;
        for (let i = 0; i < messages.data.current.length; i++) {

            if (messages.data.current[i]?.y === null || messages.data.voltage[i]?.y === null) {
                item = null
            }
            if (Math.abs(messages.data.current[i]?.y) < 10 && messages.data.current[i]?.y != null) {
                item = +0
            }
            if (Math.abs(messages.data.current[i]?.y) > 10) {
                item = (messages.data.current[i]?.y * messages.data.voltage[i]?.y).toFixed(1);
            }
            power.push({x: new Date(messages.data.current[i]?.x), y: item})
        }
        messages.setData('power', power)
    }

    const toggleModal = () => {
        setIsModal(prevState => !prevState)
    }
//------API запросы-----------------
    const gd = async () => {
        const {data} = await getDevice(things.id);
        things.setEquipment('description', data.metadata.equipment.description)
        things.setEquipment('facility', data.metadata.equipment.facility)
        things.setEquipment('manufacturer', data.metadata.equipment.manufacturer)
        things.setEquipment('model', data.metadata.equipment.model)
        things.setEquipment('sn', data.metadata.equipment.sn)
        things.setEquipment('type', data.metadata.equipment.type)
        things.setEquipment('city', data.metadata.equipment.city)
        things.setEquipment('address', data.metadata.equipment.address)
        data.metadata.settings?.voltage_factor ? things.setSettings('voltage', data.metadata.settings?.voltage_factor) : things.setSettings('voltage', 1)
        data.metadata.settings?.current_factor ? things.setSettings('current', data.metadata.settings?.current_factor) : things.setSettings('current', 1)
        setDescription(data.metadata.equipment.description)
        setFacility(data.metadata.equipment.facility)
        setManufacturer(data.metadata.equipment.manufacturer)
        setModel(data.metadata.equipment.model)
        setSn(data.metadata.equipment.sn)
        setType(data.metadata.equipment.type)
        setAddress(data.metadata.equipment.address)
        setCity(data.metadata.equipment.city)
        setVoltageFactor((data.metadata.settings?.voltage_factor))
        setCurrentFactor((data.metadata.settings?.current_factor))

    }
    const intPowerCapacity = (current, voltage = 1) => {
        const diff = 3600000
        let discharge = 0
        let charge = 0
        if (voltage === 1) {
            for (let i = 0; i < current.length - 2; i++) {
                if (current[i].y < -5) {
                    discharge += (+new Date(current[i].x) - +new Date(current[i + 1].x)) * Math.abs(+current[i]?.y + +current[i + 1]?.y) / 2 / diff
                } else if (current[i].y > 0) {
                    charge += (+new Date(current[i].x) - +new Date(current[i + 1].x)) * Math.abs(+current[i]?.y + +current[i + 1]?.y) / 2 / diff
                }
            }
        } else {
            for (let i = 0; i < current.length - 2; i++) {
                if (current[i].y < -5) {
                    discharge += (+new Date(current[i].x) - +new Date(current[i + 1].x)) * Math.abs(+current[i]?.y + +current[i + 1]?.y) * Math.abs(+voltage[i]?.y + +voltage[i + 1]?.y) / 4 / diff
                } else if (current[i].y > 0) {
                    charge += (+new Date(current[i].x) - +new Date(current[i + 1].x)) * Math.abs(+current[i]?.y + +current[i + 1]?.y) * Math.abs(+voltage[i]?.y + +voltage[i + 1]?.y) / 4 / diff
                }
            }
        }
        return {discharge: discharge.toFixed(1), charge: charge.toFixed(1)}
    }
    const updateDeviceMetadata = async () => {
        try {
            await updateDevice(things.id, things.key, metadata, things.name);
            sendPdo().then()
            toggleModal();
            gd().then()
        } catch (e) {
        }
    }
    let v = [];
    let c = [];
    let t = [];
    let h = [];
    const gv = async (firstTime, lastTime) => {
        try {
            let lt;
            const {data} = await getVoltage(things.name, channels.channelId, (firstTime.unix()), lastTime.unix());
            messages.setTotalVoltage(data.total)
            lt = lastTime
            while (messages.totalVoltage > 0) {
                const {data} = await getVoltage(things.name, channels.channelId, (firstTime.unix()), (lt.unix()));
                lt = dayjs.unix(data.messages[data.messages.length - 1].time)
                messages.setTotalVoltage(messages.totalVoltage - data.messages.length)
                v.push(...data.messages.map(({time, value}) => ({
                    x: new Date(time * 1000), y: (value * things.settings.voltage_factor).toFixed(1)
                })))
            }
        } catch (e) {
        }
    }
    const gi = async (firstTime, lastTime) => {
        try {
            let lt;
            const {data} = await getCurrent(things.name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            messages.setTotalCurrent(data.total)
            lt = lastTime
            while (messages.totalCurrent > 0) {
                const {data} = await getCurrent(things.name, channels.channelId, (firstTime.unix()), (lt.unix()));
                lt = dayjs.unix(data.messages[data.messages.length - 1].time)
                messages.setTotalCurrent(messages.totalCurrent - data.messages.length)
                c.push(...data.messages.map(({time, value}) => ({
                    x: new Date(time * 1000), y: (value * things.settings.current_factor).toFixed(1)
                })))
            }
        } catch (e) {
        }
    }
    const gt = async (firstTime, lastTime) => {
        try {
            let lt;
            const {data} = await getTemperature(things.name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            messages.setTotalTemperature(data.total)
            lt = lastTime
            while (messages.totalTemperature > 0) {
                const {data} = await getTemperature(things.name, channels.channelId, (firstTime.unix()), (lt.unix()));
                lt = dayjs.unix(data.messages[data.messages.length - 1].time)
                messages.setTotalTemperature(messages.totalTemperature - data.messages.length)
                t.push(...data.messages.map(({time, value}) => ({
                    x: new Date(time * 1000), y: value.toFixed(1)
                })))
            }
        } catch (e) {
        }
    }
    const gh = async (firstTime, lastTime) => {
        try {
            let lt;
            const {data} = await getHumidity(things.name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            messages.setTotalHumidity(data.total)
            lt = lastTime
            while (messages.totalHumidity > 0) {
                const {data} = await getHumidity(things.name, channels.channelId, (firstTime.unix()), (lt.unix()));
                lt = dayjs.unix(data.messages[data.messages.length - 1].time)
                messages.setTotalHumidity(messages.totalHumidity - data.messages.length)
                h.push(...data.messages.map(({time, value}) => ({
                    x: new Date(time * 1000), y: value.toFixed(1)
                })))
            }
        } catch (e) {
        }
    }
    const gLat = async () => {
        try {
            const {data} = await getLat(things.name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            messages.setLocation('lat', data.messages[0].value);
        } catch (e) {
            messages.setLocation('lat', 0)
        }
    }
    const gLon = async () => {
        try {
            const {data} = await getLon(things.name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            messages.setLocation('lon', data.messages[0].value);
        } catch (e) {
            messages.setLocation('lon', 0)
        }
    }
    const gIMEI = async () => {
        try {
            const {data} = await getIMEI(things.name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            messages.setImei('-');
            messages.setImei(data.messages[0].string_value);
        } catch (e) {
        }

    }
    const gICCID = async () => {
        try {
            const {data} = await getICCID(things.name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            messages.setIccid('-');
            messages.setIccid(data.messages[0].string_value);
        } catch (e) {
        }
    }
    const gFW = async () => {
        try {
            const {data} = await getFW(things.name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            messages.setFW('-');
            messages.setFW(data.messages[0].string_value);
        } catch (e) {
        }
    }
    const gHW = async () => {
        try {
            const {data} = await getHW(things.name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            messages.setHW('-');
            messages.setHW(data.messages[0].string_value);
        } catch (e) {
        }
    }
    const gPem = async () => {
        try {
            const {data} = await fetchCert(certUrls[0], auth);
            cert.setPem(data)
        } catch (e) {
        }
    }
    const gCrt = async () => {
        try {
            const {data} = await fetchCert(certUrls[1], auth);
            cert.setCrt(data)
        } catch (e) {
        }
    }
    const gKey = async () => {
        try {
            const {data} = await fetchCert(certUrls[2], auth);
            cert.setKey(data)
        } catch (e) {
        }
    }
    const gPdo0 = async () => {
        try {
            const {data} = await getPdo0(things.name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            messages.setPdo0(data.messages[0].bool_value)
        } catch (e) {
        }
    }
    const gPdo1 = async () => {
        try {
            const {data} = await getPdo1(things.name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            messages.setPdo1(data.messages[0].bool_value)
        } catch (e) {
        }
    }
    const gCode = async () => {
        try {
            const {data} = await getCode(things.name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            messages.setCode([])
            messages.setCode(code(data.messages))
        } catch (e) {
        }
    }
    const gRSSI = async () => {
        try {
            const {data} = await getRSSI(things.name, channels.channelId, (firstTime.unix()), (lastTime.unix()));
            messages.setRSSI(0)
            messages.setRSSI(data.messages[0].value)
        } catch (e) {
        }
    }
    const translateRSSI = () => {
        let rssi = 2 * messages.RSSI - 113
        if (!things.isDeviceOnline) {
            return <Icon path={mdiSignalCellularOutline} size={2} color={'gray'}/>
        } else if (rssi >= -70) {
            return <Icon path={mdiSignalCellular3} size={2} color={'green'}/>
        } else if (rssi >= -85) {
            return <Icon path={mdiSignalCellular2} size={2} color={'orange'}/>
        } else if (rssi >= -100) {
            return <Icon path={mdiSignalCellular1} size={2} color={'red'}/>
        } else {
            return <Icon path={mdiSignalCellularOutline} size={2} color={'gray'}/>
        }
    }
    const sendPdo = async () => {
        const options = {
            clean: true,
            connectTimeout: 40000,
            clientId: 'mqttjs_' + Math.random().toString(16).substr(2, 8),
            username: things.gate.id,
            password: things.gate.key, // username: 'c930c713-d752-4429-8fd7-ed96aca3956a',
            // password: '94887ba2-8e12-4bcf-a1a7-8d26ed17dd82',
            // key: cert.key,
            // cert: cert.crt,
            // ca: cert.pem,
            rejectUnauthorized: false,
            protocolVersion: 4,
        }

        let channelId = channels.channelId
        let topic = 'channels/' + channelId + '/messages/ctrl'
        const connectUrl = 'wss://iot.faradaydc.ru:443/mqtt'
        const client = mqtt.connect(connectUrl, options)


        client.on('error', (error) => {
            // console.log('Connection failed:', error)
        })

        client.on('connect', function () {
            // console.log('client connected:' + options.clientId)
            // client.subscribe(topic, { qos: 0 })
            client.publish(topic, cborCoder(things.name, messages.pdo0, messages.pdo1), {qos: 0, retain: false})
            // console.log(cborCoder(things.name, messages.pdo0).toString('hex'))
            // console.log('success')
        })

        client.on('message', function (topic, message, packet) {
            // console.log('Received Message:= ' + message.toString() + '\nOn topic:= ' + topic)
        })

        client.on('close', function () {
            // console.log(options.clientId + ' disconnected')
        })
    }
    const load = async () => {
        try {
            const {data} = await checkAuth(user.userId)
            user.setUserId(data.id);
            user.setIsAuth(true);
            user.setUser('email', data.email)
        } catch (e) {
            user.setUserId(null);
            user.setIsAuth(false);
            navigate(AUTH_ROUTE)
        }
    }

//------Вызов функций---------------
    useEffect(() => {
        load().then(() => {
            if (user.isAuth) {
                window.scrollTo(0, 0)
                setIsIMEI(false)
                setIsICCID(false)
                setIsFW(false)
                setIsHW(false)
                setIsMeta(false)
                setIsPdo0(false)
                setIsPdo1(false)
                ui.setIsPower(true)
                ui.setIsVoltage(true)
                ui.setIsCurrent(true)
                ui.setIsTemperature(true)
                ui.setIsHumidity(true)
                ui.setIsLat(false)
                ui.setIsLon(false)
                gLat().then(() => {
                    ui.setIsLat(true)
                })
                gLon().then(() => {
                    ui.setIsLon(true)
                })
                gIMEI().then(() => {
                    setIsIMEI(true)
                })
                gICCID().then(() => {
                    setIsICCID(true)
                })
                gFW().then(() => {
                    setIsFW(true)
                })
                gHW().then(() => {
                    setIsHW(true)
                })
                gd().then(() => {
                    setIsMeta(true)
                })
                gPem().then()
                gCrt().then()
                gKey().then()
                gPdo0().then(() => setIsPdo0(true))
                gPdo1().then(() => setIsPdo1(true))
                gRSSI().then()
            } else {
                navigate(AUTH_ROUTE)
            }
        })
    }, []);
    useEffect(() => {
        load().then(() => {
            if (user.isAuth) {
                setIsVoltage(false)
                setIsCurrent(false)
                setIsTemperature(false)
                setIsHumidity(false)
                v = [];
                c = [];
                t = [];
                h = [];
                messages.setData('voltage', v)
                messages.setData('current', c)
                messages.setData('temperature', t)
                messages.setData('humidity', h)
                gv(firstTime, lastTime).then(() => {
                    messages.setData('voltage', v)
                    messages.data.voltage[0]?.y >= 0 ? setVoltage(messages.data.voltage[0].y) : setVoltage(0)
                    nullFilter(messages,'voltage', messages.data.voltage)
                    setIsVoltage(true)
                    gi(firstTime, lastTime).then(() => {
                        messages.setData('current', c)
                        let _working = messages.data.current.reduce((acc, cur, idx, src) => {
                            if (idx === 0) {
                                return 0;
                            }
                            if (cur.y > -10) {
                                return acc;
                            }
                            let prev = src[idx - 1];
                            let delta = prev.x - cur.x;
                            return acc + delta;
                        }, 0) / 3600000;
                        setWorking(_working.toFixed(1));
                        let _idle = messages.data.current.reduce((acc, cur, idx, src) => {
                            if (idx === 0) {
                                return 0;
                            }
                            if (cur.y < -10 || cur.y > 10) {
                                return acc;
                            }
                            let prev = src[idx - 1];
                            let delta = prev.x - cur.x;
                            return acc + delta;
                        }, 0) / 3600000;
                        setIdle(_idle.toFixed(1));
                        let _charging = messages.data.current.reduce((acc, cur, idx, src) => {
                            if (idx === 0) {
                                return 0;
                            }
                            if (cur.y < 10) {
                                return acc;
                            }
                            let prev = src[idx - 1];
                            let delta = prev.x - cur.x;
                            return acc + delta;
                        }, 0) / 3600000;

                        setCharging(_charging.toFixed(1));
                        let _efficiency = (+_working / (+_working + +_idle + +_charging)) * 100;
                        if (isNaN(_efficiency)) {
                            setEfficiency(0)
                        } else {
                            setEfficiency(_efficiency.toFixed(0))
                        }
                        messages.data.current[0]?.y >= 0 ? setCurrent(messages.data.current[0].y) : setCurrent(0)
                        nullFilter(messages,'current', messages.data.current)
                    }).then(() => {
                        setIsCurrent(true);
                        powerChart();
                    })
                })

                if (isVoltage && isCurrent) {
                }
                gt(firstTime, lastTime).then(() => {
                    messages.setData('temperature', t)
                    messages.data.temperature[0]?.y >= 0 ? setTemperature(messages.data.temperature[0].y) : setTemperature(0)
                    nullFilter(messages,'temperature', messages.data.temperature)
                    setIsTemperature(true)
                })
                gh(firstTime, lastTime).then(() => {
                    messages.setData('humidity', h)
                    messages.data.humidity[0]?.y >= 0 ? setHumidity(messages.data.humidity[0].y) : setHumidity(0)
                    nullFilter(messages,'humidity', messages.data.humidity)
                    setIsHumidity(true)
                })
                gCode().then()
            } else {
                navigate(AUTH_ROUTE)
            }
        })
    }, [update])

    const RenderPieChart = () => {
        const a = intPowerCapacity(messages.data.current, messages.data.voltage)
        const b = intPowerCapacity(messages.data.current)
        setIntPower([+a.discharge, +a.charge])
        setIntCapacity([+b.discharge, +b.charge])
        setDiffTime((lastTime.diff(firstTime) / 3600000))
    }

    useEffect(() => {
        setIsPieChart(false)
        if (isVoltage && isCurrent) {
            RenderPieChart()
            setIsPieChart(true)
        }
    }, [isVoltage, isCurrent])


//------Данные графиков-------------
    const chartData = [{
        data: messages.data.voltage,
        color: ["#008FFB"],
        unit: "В",
        form: 1,
        title: "Напряжение",
        id: 0,
        ui: ui.isVoltage,
        isFetch: (isVoltage & isCurrent & isTemperature & isHumidity)
    }, {
        data: messages.data.current,
        color: ["#00E396"],
        unit: "А",
        form: 1,
        title: "Ток",
        id: 1,
        ui: ui.isCurrent,
        isFetch: (isVoltage & isCurrent & isTemperature & isHumidity)

    }, {
        data: messages.data.temperature,
        color: ["#FEB019"],
        unit: "°C",
        form: 1,
        title: "Температура",
        id: 2,
        ui: ui.isTemperature,
        isFetch: (isVoltage & isCurrent & isTemperature & isHumidity)

    }, {
        data: messages.data.humidity,
        color: ["#FF4560"],
        unit: "%",
        form: 1,
        title: "Влажность",
        id: 3,
        ui: ui.isHumidity,
        isFetch: (isVoltage & isCurrent & isTemperature & isHumidity)

    }, {
        data: messages.data.power,
        color: ["#ff00ff"],
        unit: "Вт",
        form: 1,
        title: "Мощность",
        id: 4,
        ui: ui.isPower,
        isFetch: (isVoltage & isCurrent & isTemperature & isHumidity)
    }]
    const CardDeviceInfo = [{
        key: 'Серийный номер:', value: things.serialNumber,
    }, {
        key: 'Модель:', value: things.model.toUpperCase(),
    }, {
        key: 'IMEI:', value: messages.imei, function: handleCopyText,
    }, {
        key: 'ICCID:', value: messages.iccid, function: handleCopyText,
    }, {
        key: 'Версия ПО:', value: messages.fw,
    }, {
        key: 'Версия АО:', value: messages.hw,
    },]

    const CardMachineInfo = [{
        key: 'Серийный номер:', value: things.equipment.sn,
    }, {
        key: 'Производитель:', value: things.equipment.manufacturer,
    }, {
        key: 'Модель:', value: things.equipment.model,
    }, {
        key: 'Объект:', value: things.equipment.facility,
    }, {
        key: 'Тип:', value: things.equipment.type,
    }, {
        key: 'Описание:', value: things.equipment.description,
    },]
    const PieChartWorking = {
        x: {
            labels: ['Разряд', 'Заряд', 'Простой'], value: [+working, +charging, +idle], unit: 'ч',
        }, total: {
            name: 'Использование', value: efficiency, unit: '%',
        },
    }
    const PieChartPower = {
        x: {
            labels: ['Разряд', 'Заряд'], value: intPower, unit: 'Вт·ч',
        }, total: {
            name: 'Диапазон', value: diffTime.toFixed(1), unit: 'ч',
        },
    }
    const PieChartCapacity = {
        x: {
            labels: ['Разряд', 'Заряд'], value: intCapacity, unit: 'А·ч',
        }, total: {
            name: 'Диапазон', value: diffTime.toFixed(1), unit: 'ч',
        },
    }
//------Разметка страницы-----------
    return (<>
        <div className={classes.header}>
            <div className={classes.header_name}>
                <h1>Устройство</h1>
                {things.isDeviceOnline ? <Icon size={1.2} path={mdiWifi} color={'#55ce5e'}/> :
                    <Icon size={1.2} path={mdiWifiCancel} color={'red'}/>}
            </div>
            <button className={classes.icon}
                    disabled={((isFW & isHW & isICCID & isIMEI & isMeta & isPdo0 & isPdo1) !== 1)}
                    onClick={toggleModal}><Icon size={1.5} path={mdiCog}/>
            </button>
        </div>
        <div className={classes.container}>
            <div className={classes.general_card}>
                <MainCard info={CardMachineInfo} img={machine}>
                    {(isFW & isHW & isICCID & isIMEI & isMeta & isPdo0 & isPdo1) === 1 ? undefined : <Loader/>}
                </MainCard>
                <MainCard info={CardDeviceInfo} img={device}>
                    {(isFW & isHW & isICCID & isIMEI & isMeta & isPdo0 & isPdo1) === 1 ? undefined : <Loader/>}
                </MainCard>
            </div>
            <div className={classes.timeStep}>
                <button className={classes.arrow} onClick={() => {
                    let r = lastTime.diff(firstTime);
                    let d = dayjs(lastTime).subtract(r)
                    setLastTime(d)
                    let a = dayjs(firstTime).subtract(r)
                    setFirstTime(a)
                    setUpdate(!update)
                }}><Icon path={mdiChevronLeft} size={2}/></button>
                <DateAndTimePicker>
                    <DateTimePicker viewRenderers={null}
                                    format={'YYYY-MM-DD HH:mm'}
                                    minDateTime={dayjs('2024-01-26T00:00')}
                                    maxDateTime={dayjs()}
                                    ampm={false} label="Начало"
                                    value={firstTime}
                                    onChange={(newValue) => {
                                        setFirstTime(newValue)
                                        setRange(24)
                                    }}
                                    onClose={() => setUpdate(!update)}
                    />
                    <DateTimePicker viewRenderers={null}
                                    format={'YYYY-MM-DD HH:mm'}
                                    minDateTime={firstTime}
                                    maxDateTime={maxLastTime}
                                    ampm={false} label="Конец"
                                    value={lastTime}
                                    onChange={(newValue) => setLastTime(newValue)}
                                    onClose={() => setUpdate(!update)}
                    />
                </DateAndTimePicker>
                <button style={{marginLeft: '1rem'}} className={classes.arrow} onClick={() => {
                    let r = lastTime.diff(firstTime);
                    let d = dayjs(lastTime).add(r)
                    if (d > dayjs()) {
                        d = dayjs()
                        setMaxLastTime(d)
                    }
                    setLastTime(d)
                    setFirstTime(d.subtract(r))
                    setUpdate(!update)
                }}><Icon path={mdiChevronRight} size={2}/></button>
                <button className={classes.changeTime} onClick={() => {
                    updateFirstTime(2)
                    setUpdate(!update)
                }}>2 часа
                </button>
                <button className={classes.changeTime} onClick={() => {
                    updateFirstTime(12)
                    setUpdate(!update)
                }}>12 часов
                </button>
                <button className={classes.changeTime} onClick={() => {
                    updateFirstTime(24)
                    setUpdate(!update)
                }}>24 часа
                </button>
                <button className={classes.changeTime} onClick={() => {
                    updateFirstTime(24 * 7)
                    setUpdate(!update)
                }}>7 дней
                </button>

            </div>

            <div className={classes.current_parameters}>
                <div className={classes.block_item}>
                    <Card name={chartData[0].title} value={voltage} unit={chartData[0].unit}>
                        {(isVoltage & isCurrent & isTemperature & isHumidity) === 1 ? undefined : <Loader/>}
                    </Card>
                    <Card name={chartData[1].title} value={current} unit={chartData[1].unit}>
                        {(isVoltage & isCurrent & isTemperature & isHumidity) === 1 ? undefined : <Loader/>}
                    </Card>
                    <Card name={chartData[2].title} value={temperature} unit={chartData[2].unit}>
                        {(isVoltage & isCurrent & isTemperature & isHumidity) === 1 ? undefined : <Loader/>}
                    </Card>
                    <Card name={chartData[3].title} value={humidity} unit={chartData[3].unit}>
                        {(isVoltage & isCurrent & isTemperature & isHumidity) === 1 ? undefined : <Loader/>}
                    </Card>
                    <Card name={'Расход'}
                          value={(isNaN(+intPower[0] / +working) || !isFinite(+intPower[0] / +working)) ? '0' : (+intPower[0] / +working).toFixed(1)}
                          unit={'Вт·ч/ч'}>
                        {(isVoltage & isCurrent & isTemperature & isHumidity) === 1 ? undefined : <Loader/>}
                    </Card>
                    <Card>
                        {(isVoltage & isCurrent & isTemperature & isHumidity) === 1 ? translateRSSI() : <Loader/>}
                    </Card>
                </div>
                <div className={classes.block_item}>
                    <Card height={270}>
                        {(isVoltage & isCurrent & isTemperature & isHumidity & isPieChart) === 1 ?
                            <PieChart name={'Использование'} data={PieChartWorking}/> : <Loader/>}
                    </Card>
                    <Card height={270}>
                        {(isVoltage & isCurrent & isTemperature & isHumidity & isPieChart) === 1 ?
                            <PieChart name={'Энергия'} data={PieChartPower}/> : <Loader/>}
                    </Card>
                    <Card height={270}>
                        {(isVoltage & isCurrent & isTemperature & isHumidity & isPieChart) === 1 ?
                            <PieChart name={'Емкость'} data={PieChartCapacity}/> : <Loader/>}
                    </Card>
                </div>
            </div>
            <div className={classes.graphics}>

                {chartData.map(({data, color, unit, form, title, id, ui, isFetch}) =>
                    <Chart isFetch={isFetch}
                           ui={ui}
                           key={id}
                           color={color}
                           unit={unit}
                           form={form}
                           title={title}
                           id={id}
                           data={data}
                           group={'group'}/>)}
            </div>
            <div className={classes.evt_map}>
                <div className={classes.event_wrapper} style={ui.isEvent ? {display: 'flex'} : {display: 'none'}}>
                    <h2>События</h2>
                    {(isVoltage & isCurrent & isTemperature & isHumidity & isPieChart) === 1 ?
                        <div className={classes.table}>
                            <div className={classes.table_name_item}>
                                <span>Время</span>
                                <span>Код</span>
                                <span>Описание</span>
                            </div>

                            <div className={classes.table_item}>
                                {messages.code.map((i) => {
                                    return (<div key={i.time} className={classes.item}>
                                        <span>{i.time}</span>
                                        <span>{i.code}</span>
                                        <span>{i.desc}</span>
                                    </div>)
                                })}
                            </div>
                        </div> : <Loader/>}
                </div>

                <div className={classes.map_wrapper} style={ui.isMap ? {display: 'flex'} : {display: 'none'}}>
                    {ui.isLat && ui.isLon ? messages.location.lon && messages.location.lat ? <YMaps>
                        <Map width={'100%'} height={'100%'}
                             defaultState={{
                                 center: [messages.location.lat, messages.location.lon,], zoom: 9
                             }}>
                            <Placemark geometry={[messages.location.lat, messages.location.lon,]}/>
                        </Map>
                    </YMaps> : <div className={classes.hide}>
                        <p>Извините, данных для отображения нет</p>
                    </div> : <Loader/>}
                </div>
            </div>

            <div onClick={toggleModal} style={isModal ? {display: 'block'} : {display: 'none'}}
                 className={classes.modal_wrapper}/>
            <div style={isModal ? {display: 'flex'} : {display: 'none'}} className={classes.modal}>
                <h2>Настройки</h2>
                <div className={classes.input_container}>
                    <div>
                        <p>Серийный номер</p>
                        <input onChange={(e) => setSn(e.target.value)} value={sn} className={classes.input}
                               type="text"/>
                    </div>
                    <div>
                        <p>Производитель</p>
                        <input onChange={(e) => setManufacturer(e.target.value)} value={manufacturer}
                               className={classes.input} type="text"/>
                    </div>
                </div>
                <div className={classes.input_container}>
                    <div>
                        <p>Город</p>
                        <input onChange={(e) => setCity(e.target.value)} value={city} className={classes.input}
                               type="text"/>
                    </div>
                    <div>
                        <p>Адрес</p>
                        <input onChange={(e) => setAddress(e.target.value)} value={address}
                               className={classes.input} type="text"/>
                    </div>
                </div>
                <div className={classes.input_container}>
                    <div>
                        <p>Модель</p>
                        <input onChange={(e) => setModel(e.target.value)} value={model} className={classes.input}
                               type="text"/>
                    </div>
                    <div>
                        <p>Объект</p>
                        <input onChange={(e) => setFacility(e.target.value)} value={facility}
                               className={classes.input} type="text"/>
                    </div>
                </div>
                <div className={classes.input_container}>
                    <div>
                        <p>Описание</p>
                        <input onChange={(e) => setDescription(e.target.value)} value={description}
                               className={classes.input} type="text"/>
                    </div>
                    <div>
                        <p>Тип</p>
                        <input onChange={(e) => setType(e.target.value)} value={type} className={classes.input}
                               type="text"/>
                    </div>
                </div>
                <div className={classes.input_container}>
                    <div>
                        <p>Коррекция напряжения</p>
                        <input onChange={(e) => setVoltageFactor(e.target.value)} value={voltageFactor}
                               className={classes.input} type="text"/>
                    </div>
                    <div>
                        <p>Коррекция тока</p>
                        <input onChange={(e) => setCurrentFactor(e.target.value)} value={currentFactor}
                               className={classes.input} type="text"/>
                    </div>
                </div>
                <div className={classes.input_container}>
                    <div className={classes.input_switch}>
                        <FormControlLabel
                            control={<Switch
                                checked={messages.pdo0}
                                onChange={() => {
                                    messages.pdo0 ? messages.setPdo0(false) : messages.setPdo0(true)
                                    // sendPdo().then()
                                }}/>}
                            labelPlacement="start"
                            label="Силовой выход 1"/>
                    </div>
                    <div className={classes.input_switch}>
                        <FormControlLabel
                            control={<Switch
                                checked={messages.pdo1}
                                onChange={() => {
                                    messages.pdo1 ? messages.setPdo1(false) : messages.setPdo1(true)
                                    // sendPdo().then()
                                }}/>}
                            labelPlacement="start"
                            label="Силовой выход 2"/>
                    </div>
                </div>
                <div className={classes.input_container}>
                    <button onClick={updateDeviceMetadata} className={classes.modal_btn}>Сохранить</button>
                    <button onClick={toggleModal} className={classes.modal_btn_close}>Закрыть</button>
                </div>
            </div>
        </div>
    </>)
});

export default Dashboard;